import React from 'react'
import type {
  InterviewQuestionOptionsResource,
  InterviewQuestionValidationsResource,
} from '@entities/api/Interview'
import { RegisterOptions, useFormContext } from 'react-hook-form'

interface Props {
  prefix: string
  itemName: string | null
  required: boolean
  options?: InterviewQuestionOptionsResource | null
  validations?: InterviewQuestionValidationsResource | null
}

const InputNumber: React.FC<Props> = ({ prefix, itemName, required, options, validations }) => {
  const { register } = useFormContext()
  const errorPrefix = `${itemName ? `${itemName}について、` : ''}`

  const rules: RegisterOptions = {
    valueAsNumber: true,
    required: required && `${errorPrefix}値を入力してください`,
  }

  let inputMode: 'numeric' | 'decimal' = 'numeric'
  if (options?.input_mode) {
    inputMode = options.input_mode as 'numeric' | 'decimal'
  }
  let step = 1
  if (options?.step) {
    step = options.step
  }

  if (validations?.min || validations?.min === 0) {
    rules.min = {
      value: validations.min,
      message: `${errorPrefix}${validations.min}以上の値を入力してください`,
    }
  }
  if (validations?.max || validations?.max === 0) {
    rules.max = {
      value: validations.max,
      message: `${errorPrefix}${validations.max}以下の値を入力してください`,
    }
  }

  return (
    <div className="row justify-content-center pb-4">
      <div className="col input-group">
        <input
          ref={register(rules)}
          type="number"
          inputMode={inputMode}
          step={step}
          name={`${prefix}.value`}
          className="form-control border border-light bg-light"
          placeholder={options?.placeholder}
          aria-describedby={options?.unit && `${prefix}_value`}
        />
        {options?.unit && (
          <div className="input-group-append">
            <span id={`${prefix}_value`} className="input-group-text border-light bg-light">
              {options.unit}
            </span>
          </div>
        )}
      </div>
    </div>
  )
}

export default InputNumber
